<div class="backgroundDark">
    <h2 mat-dialog-title class="marginBottom0" fxFlex>Video Playback</h2>
    <button mat-icon-button fxLayoutAlign="end center" (click)="close(false)">
        <mat-icon aria-label="Close" class="headerIconButton">close</mat-icon>
    </button>
</div>

<mat-dialog-content style="max-height: 95%; padding: 0 !important;">
    <form [formGroup]="videoFormGroup" (ngSubmit)="saveDocumentDetails(submitBtn)" novalidate autocomplete="off">
        <mat-card class="mainStepperCard">
            <mat-card-content class="mainStepperCardContent" style="background: #f2f2f2;">
                <mat-card class="stepperCard">
                    <mat-card-header>
                        <mat-card-title>{{checkListItem.orientationCheckListItemDescription}}</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="fileUrl && !cannotBeModified">
                            <video [src]="fileUrl | safeResourceUrl" controls class="video" disablepictureinpicture controlsList="nodownload">
                                Your browser does not support HTML5 video.
                            </video>
                        </div>
                        <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="fileUrl && cannotBeModified">
                            <video [src]="fileUrl | safeResourceUrl" class="video" disablepictureinpicture>
                                Your browser does not support HTML5 video.
                            </video>
                        </div>
                        <p class="aspectRatio" *ngIf="youTubeUrl && !cannotBeModified">
                            <iframe [src]="youTubeUrl"> </iframe>
                        </p>
                        <p class="aspectRatio" *ngIf="youTubeUrl && cannotBeModified">
                            <img class="videoPlaceholder" [src]="youTubeUrl" />
                        </p>
                    </mat-card-content>
                </mat-card>

                <mat-card class="stepperCard questionCard">
                    <mat-card-header>
                        <mat-card-title>Questions</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div fxLayout="column">
                            <div fxLayout="row" fxFlex="100%" class="marginBottom10" *ngFor="let item of videoQuestions; let i = index">
                                <div fxLayout="column" fxFlex="100%">
                                    <!--<div style="font-weight: 500" fxLayout="row" fxFlex="100%"><mat-icon class="questionIcon" [ngClass]="{'yellowIcon': item.isMandatory && item.notAnswered, 'greenIcon': item.allAnswersCorrect && !item.notAnswered, 'redIcon': !item.allAnswersCorrect && !item.notAnswered, 'greyIcon': !item.isMandatory && item.notAnswered}" [matTooltip]="item.isMandatory && item.notAnswered ? 'Mandatory Question Not Answered' : !item.isMandatory && item.notAnswered ? 'Optional Question Not Answered' : item.allAnswersCorrect && !item.notAnswered ? 'Question Answered Correctly' : 'Question Not Correctly Answered'">assignment_late</mat-icon>{{!item.isMandatory ? "(Optional) " : ""}}{{item.description}}</div>-->
                                    <div style="font-weight: 500" fxLayout="row" fxFlex="100%"><mat-icon class="questionIcon" [ngClass]="{'yellowIcon': !cannotBeModified && item.isMandatory, 'greenIcon': item.allAnswersCorrect && cannotBeModified, 'greyIcon': !cannotBeModified && !item.isMandatory}" [matTooltip]="!cannotBeModified && item.isMandatory ? 'Mandatory Question' : !cannotBeModified && !item.isMandatory ? 'Optional Question' : 'Question Answered Correctly'">assignment_late</mat-icon>{{!item.isMandatory ? "(Optional) " : ""}}{{item.description}}</div>
                                    <div fxLayout="row" fxFlex="100%" *ngFor="let answer of item.orientationCheckListItemQuestionAnswers; let j = index">
                                        <mat-checkbox formControlName="answer{{answer.id}}" class="marginTop10" color="primary" (change)="markQuestionCompleted($event, answer)">{{answer.description}}</mat-checkbox>
                                    </div>
                                    <div fxFlex="100%" *ngIf="i < videoQuestions.length -1"><br /></div>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </mat-card-content>
            <mat-divider class="dividerColor"></mat-divider>
            <mat-card-actions fxLayoutAlign="end center">
                <button class="mat-raised-button dialogActionButton" mat-button (click)="close(false)" type="button">Cancel</button>
                <button class="mat-raised-button dialogActionButton" mat-button color="primary" type="submit" [disabled]="!videoFormGroup.dirty || videoFormGroup.invalid" #submitBtn>Complete</button>
            </mat-card-actions>
        </mat-card>
    </form>
</mat-dialog-content>
